import Icon, { ICON_LEFT } from '~/components/icon/index.js';

/**
 * @param { {onClick: React.ReactEventHandler, className: string, 'data-at'?: string, type?: 'button' | 'submit'} } props
 */
function IconChevronLeftButton({ onClick, className, 'data-at': dataAt, type = 'button', style }) {
	return (
		/**
		 * Agree to disagree https://github.com/yannickcr/eslint-plugin-react/issues/1555#issuecomment-377339656
		 */

		/* eslint-disable react/button-has-type */
		<button type={type} onClick={onClick} data-at={dataAt} style={style}>
			<Icon type={ICON_LEFT} className={className} />
		</button>
		/* eslint-enable react/button-has-type */
	);
}

export default IconChevronLeftButton;
